import { render, staticRenderFns } from "./CustomerRelatedOrder.vue?vue&type=template&id=358902ef&"
import script from "./CustomerRelatedOrder.vue?vue&type=script&lang=ts&"
export * from "./CustomerRelatedOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports